import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  inquiries: [],
};

const inquiriesSlice = createSlice({
  name: "inquiries",
  initialState,
  reducers: {
    loadInquiriesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadInquiriesSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.inquiries = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadInquiriesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadInquiriesFail,
  loadInquiriesRequested,
  loadInquiriesSuccess,
} = inquiriesSlice.actions;

export default inquiriesSlice.reducer;
